// Levels and the live estimate of report points. The server has the final say (compute_report_points in the service);
// keep the numbers in sync with it.
export const LEVELS = [
  { key: 'newcomer', min: 0 },
  { key: 'rider', min: 100 },
  { key: 'pathfinder', min: 300 },
  { key: 'streetwise', min: 600 },
  { key: 'hero', min: 1000 },
];

export function levelFor(points) {
  const p = Number(points) || 0;
  let index = 0;
  LEVELS.forEach((l, i) => { if (p >= l.min) index = i; });
  const next = LEVELS[index + 1] || null;
  const progress = next ? (p - LEVELS[index].min) / (next.min - LEVELS[index].min) : 1;
  return { index, key: LEVELS[index].key, next, progress, toNext: next ? Math.ceil(next.min - p) : 0 };
}

export const MAX_REPORT_POINTS = 40;

// [{ key, points, done }] for the detail meter
export function estimatePoints({ rating, labels, comment, ideas }) {
  const answers = rating && Array.isArray(rating.answers) ? rating.answers.length : 0;
  const len = (comment || '').trim().length;
  const rows = [
    { key: 'base', points: 10, done: true },
    { key: 'rating', points: rating && rating.kind === 'good' ? 3 : 2 * Math.min(Math.max(answers, 1), 3), done: !!rating && (rating.kind === 'good' || answers > 0) },
    { key: 'labels', points: 3, done: Array.isArray(labels) && labels.length > 0 },
    { key: 'comment', points: len >= 200 ? 10 : len >= 80 ? 6 : 3, done: len >= 20 },
    { key: 'ideas', points: ideas >= 3 ? 8 : 4, done: ideas > 0 },
    { key: 'public', points: 2, done: true },
  ];
  const total = Math.min(MAX_REPORT_POINTS, rows.filter((r) => r.done).reduce((a, r) => a + r.points, 0));
  return { rows, total };
}
